import React from 'react';

import { ActionIcon, Button, Group, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft, IconSettings } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

interface ITrackingHeaderProps {
  programName: string;
  required: number;
  onSettingsClick: () => void;
  canConfigure: boolean;
}

const TrackingHeader = ({
  programName,
  required,
  onSettingsClick,
  canConfigure,
}: ITrackingHeaderProps): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Group position='apart' align='center' noWrap>
      <Group spacing='sm' align='flex-start' noWrap>
        <ActionIcon variant='subtle' onClick={() => navigate('/')} aria-label='Back to dashboard'>
          <IconArrowLeft size={20} />
        </ActionIcon>
        <Stack spacing={0}>
          <Title order={3}>{programName}</Title>
          <Text color='dimmed' size='sm'>
            {required} check-ins required per month
          </Text>
        </Stack>
      </Group>
      {canConfigure && (
        <Button variant='default' leftIcon={<IconSettings size={16} />} onClick={onSettingsClick}>
          Settings
        </Button>
      )}
    </Group>
  );
};

export default TrackingHeader;
